import React, { Fragment } from 'react';
import Header from '../../components/header/Header';
import Hero from '../../components/hero/hero';
import CompanyDescription from '../../components/companyDescription/CompanyDescription';
import AboutUs from '../../components/aboutUs/AboutUs';
import Testimonials from '../../components/testimonials/Testimonials';
import FeedbackSection from '../../components/feedbackForm/FeedbackSection';
import Footer from '../../components/footer/Footer';

const HomePage = () => {
    return (
        <Fragment>
            <div className='index_ico page_wrapper'>
                <Header />
                <main className="page_content">
                    <Hero />
                    <CompanyDescription />
                    <AboutUs />
                    <Testimonials />
                    <FeedbackSection />
                </main>
                <Footer />
            </div>
        </Fragment>
    )
};
export default HomePage;
